import type { VesselCardCpIndicatorBand } from "../models/vessel-card.models";

// Uses the confirmed HSFO/VLSFO names for IMOS IFO/LSF fuel grades.
// Assumes proxy vessels start with No on each load, using the original VLSFO design consumption.
export const VESSEL_CARD_FUEL_GRADE_WITH_SCRUBBER = "HSFO";
export const VESSEL_CARD_FUEL_GRADE_WITHOUT_SCRUBBER = "VLSFO";
export const VESSEL_CARD_DEFAULT_SCRUBBER_SELECTION = false;
export const VESSEL_CARD_OBS_ACTUAL_BASIS = "OBS_Actual";

// Uses DWT boundaries to select the agreed correction, even when the vessel type is a generic Bulk Carrier.
// Handy and Supramax share an allowance, so their overlapping 49,999 DWT boundary has no effect.
// Assumes adjacent ranges meet at the next lower boundary, including fractional DWT, with 220,000 included.
export const VESSEL_CARD_SCRUBBER_CONSUMPTION_FACTOR = 1.03;
export const VESSEL_CARD_SCRUBBER_MIN_DWT = 18_000;
export const VESSEL_CARD_SCRUBBER_KAMSARMAX_MIN_DWT = 66_000;
export const VESSEL_CARD_SCRUBBER_CAPES_MIN_DWT = 130_000;
export const VESSEL_CARD_SCRUBBER_MAX_DWT = 220_000;
export const VESSEL_CARD_SCRUBBER_HANDY_SUPRAMAX_ALLOWANCE = 0.6;
export const VESSEL_CARD_SCRUBBER_KAMSARMAX_ALLOWANCE = 0.8;
export const VESSEL_CARD_SCRUBBER_CAPES_ALLOWANCE = 1.1;
// Uses the equations in CP Desc Source - Task 419811.xlsm, Perf Indicator Logic and Exampl!F5:H5.
// Assumes that task-specific sheet's -0.2 kn in-line boundary (also L11) takes precedence,
// rather than the -0.1 kn boundary in Graph View Calcs.xlsm, Expected vs CP Graph!H3.
// Keeps full precision for classification; displayed speed rounding must not move a result into a different band.
export const VESSEL_CARD_CP_CONSUMPTION_EXPONENT = 2.8;
export const VESSEL_CARD_CP_SPEED_ABOUT_ALLOWANCE = 0.5;
export const VESSEL_CARD_CP_DOUBLE_ABOUT_CONSUMPTION_FACTOR = 1.05;
export const VESSEL_CARD_CP_MARGINAL_DOUBLE_ABOUT_ALLOWANCE = 0.2;
export const VESSEL_CARD_CP_DELTA_BANDS: VesselCardCpIndicatorBand[] = [
  { minimumDelta: 0.4, indicator: "Better Than CP", indicatorTone: "positive" },
  { minimumDelta: 0.2, indicator: "Marginally Better Than CP", indicatorTone: "neutral" },
  { minimumDelta: -0.2, indicator: "In-line with CP", indicatorTone: "neutral" },
  { minimumDelta: -0.5, indicator: "Within Speed Abt", indicatorTone: "warning" },
];
